import { useEffect } from 'react';

const useViewportHeight = () => {
  useEffect(() => {
    const setVhVariable = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    window.addEventListener('resize', setVhVariable);
    // Set the variable initially on component mount
    setVhVariable();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', setVhVariable);
    };
  }, []);
};

export default useViewportHeight;
